import React from 'react'
import styled, { css } from 'styled-components'
import { type IconProps } from '../IconPropsInterface'

const StyledSVG = styled.svg`
  ${({ hoveringColor }) =>
    hoveringColor &&
    css`
      &:hover {
        path {
          stroke: ${hoveringColor};
        }
        circle {
          stroke: ${hoveringColor};
        }
      }
    `}
`

export const Heart: React.FC<IconProps> = ({
  color = '#126554',
  hoveringColor,
}) => (
  <StyledSVG
    width="100%"
    viewBox="0 0 23 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    hoveringColor={hoveringColor}
  >
    <path
      d="M20.2652 11.014L11.5152 19.68L2.76516 11.014C2.18802 10.4524 1.73341 9.77732 1.42997 9.03138C1.12652 8.28544 0.980818 7.48475 1.00202 6.67973C1.02323 5.87471 1.21089 5.0828 1.55318 4.35387C1.89547 3.62494 2.38499 2.97477 2.9909 2.44432C3.59681 1.91386 4.30598 1.51461 5.07378 1.2717C5.84157 1.02879 6.65134 0.94749 7.45209 1.03291C8.25285 1.11833 9.02724 1.36862 9.72652 1.76803C10.4258 2.16744 11.0348 2.70731 11.5152 3.35364C11.9976 2.712 12.6073 2.17685 13.3061 1.78168C14.0049 1.38651 14.7777 1.13983 15.5762 1.05708C16.3748 0.974331 17.1818 1.05729 17.9467 1.30077C18.7117 1.54424 19.4182 1.94299 20.022 2.47207C20.6258 3.00114 21.1138 3.64914 21.4557 4.37552C21.7975 5.10189 21.9857 5.89101 22.0085 6.69347C22.0313 7.49593 21.8883 8.29447 21.5883 9.0391C21.2883 9.78373 20.8379 10.4584 20.2652 11.021"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StyledSVG>
)
